import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

interface LogoProps {
  url: string
}

export function Logo({url}: LogoProps) {

  return (
    <Button component={Link} to={url}>    
      <Typography variant="h6" color="textSecondary" sx={{fontWeight: 100, textTransform: 'capitalize'}}>MagiCAD Access Management</Typography>
    </Button>
  )
}